export default "__VITE_ASSET__3eab40b2__"